import React from 'react';
import { Box, Pagination } from '@mui/material';

const LimitedTierlistPagination = ({ totalPages, currentPage, onPageChange }) => {
    if (totalPages <= 1) {
        return null;
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Pagination
                count={totalPages}
                page={currentPage}
                onChange={onPageChange}
                color="primary"
                size="large"
                sx={{
                    '& .MuiPaginationItem-root': {
                        color: 'white',
                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                        border: '1px solid rgba(76, 29, 149, 0.3)',
                        '&:hover': {
                            backgroundColor: 'rgba(76, 29, 149, 0.4)',
                        },
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(76, 29, 149, 0.6)',
                            color: 'white',
                        }
                    }
                }}
            />
        </Box>
    );
};

export default LimitedTierlistPagination; 